import { Layout } from "@/components/layout";

const ProjectsPage = () => {
  return (
    <Layout>
      <h2 className="text-3xl font-bold mb-8">projects</h2>
      <p className="text-xl">Coming soon...</p>
    </Layout>
  );
};

export default ProjectsPage;


